import React from "react";
import { observer } from "mobx-react";
import PhoneField from "../../sharedComponents/phone/phoneField";
import { ClientModel } from "../../../helpers/client";
import Formatter from "../../../helpers/formatter";
import { runInAction } from "mobx";

interface PhoneProps {
  client: ClientModel;
}

export function Phone(props: PhoneProps) {
  const client = props.client;

  return (
    <div className="phone">
      <div className="question-answer-container">
        <div className="question">Numer telefonu</div>
        {renderPhone()}
      </div>
    </div>
  );

  function renderPhone() {
    const value = !client.phone?.value ? "" : client.phone.value;

    return (
      <div className="phone-container">
        <PhoneField
          value={value}
          onChange={(event) => {
            event.target.value = Formatter.removeNonPhoneCharacters(event.target.value.toString());
            runInAction(() => {
              // TODO: create setter and remove 'runInAction'
              client.phone.value = event.target.value;
            });
          }}
          client={client}
        />
      </div>);
  }
}

export default observer(Phone);
